import React from "react"
import { useFila } from '../../../../../../../context/FilaContext'
import { useModal } from "../../../../../../../hooks/ModalContext"

export const StartButton = () => {
  const { devedorFilaSelected } = useFila()
  const { setModal } = useModal()
  async function handleCreateChat() {
    setModal('Chat Contato', 'Chat Contato', false, false)
  }
  return (
    <>
      {
        devedorFilaSelected && !devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && <button type="button" className="bg-white flex p-4 w-[99%] h-10 justify-center items-center  text-primary font-semibold rounded-md" onClick={() => handleCreateChat()}>Iniciar conversa</button>
      }
    </>

  )
}